exports = module.exports = require("../../../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@media only screen and (max-device-width: 1024px) and (min-device-width: 768px) and (orientation: landscape) {\n.config-content .tab-content[data-v-0c4c774d] {\n    padding-bottom: 100px;\n}\n.config-content .limited-cases-tab[data-v-0c4c774d] {\n    width: 100%;\n}\n}", ""]);

// exports
